import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Drawer, Button, Row, Col, Form } from 'antd';
import { PrimaryButton, TextArea } from '@common/components';

export function DoNotRehireCommentDrawer({ visible, onClose, handleSubmit }) {
  const [form] = Form.useForm();
  const [actionButtonDisabled, setActionButtonDisabled] = useState(true);

  return (
    <Drawer
      open={visible}
      onClose={onClose}
      width={600}
      title="Reason for Submission"
      footer={
        <Row gutter={[16, 0]}>
          <Col>
            <Button key="back" onClick={onClose} size="large">
              Back
            </Button>
          </Col>
          <Col>
            <PrimaryButton
              size="large"
              key="submit"
              onClick={form.submit}
              disabled={actionButtonDisabled}
            >
              Continue
            </PrimaryButton>
          </Col>
        </Row>
      }
    >
      <Form
        layout="vertical"
        form={form}
        onFinish={(values) => handleSubmit(values.doNotRehireComment)}
      >
        <Form.Item
          colon={false}
          name="doNotRehireComment"
          rules={[
            { required: true, message: 'Please provide a comment' },
            {
              type: 'string',
              min: 1,
              max: 1000,
              message: 'Comment cannot be more than 1000 characters.',
            },
          ]}
        >
          <TextArea
            maxLength={1000}
            onChange={(value) =>
              value.target.value.length > 0
                ? setActionButtonDisabled(false)
                : setActionButtonDisabled(true)
            }
            placeholder="Please provide a detailed comment on the reason for submitting this Do Not Rehire candidate."
          />
        </Form.Item>
      </Form>
    </Drawer>
  );
}

DoNotRehireCommentDrawer.propTypes = {
  onClose: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  visible: PropTypes.bool.isRequired,
};
